module.exports = __webpack_public_path__ + "img/20191113_174609000_iOS.e2fd9b5e.jpg";